import { createAction } from '@wix/communities-blog-client-common';

export const ACTIONS_CLOSED = 'moreButton/ACTIONS_CLOSED';

export const actionsClosed = createAction(ACTIONS_CLOSED);
